import React from 'react';

interface Props {
    value: string;
}

export const ValueWithPercentSign = ({ value }: Props) => {
    if (value !== undefined) {
        return <div>{value}%</div>;
    } else {
        return <div>No value</div>;
    }
};
